import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// 認証画面のカードフェードイン/アウト時間 (ms)
// CSS 側 (frontend/public/index.html の --nexus-fade-duration) と必ず同期させること
export const FADE_DURATION_MS = 300;

/**
 * 認証画面共通のフェード制御フック
 * - マウント時にダブル requestAnimationFrame でフェードイン
 * - navigateWithFade(to) でフェードアウト → 遷移
 * - fadeOutThen(callback) で任意処理を遷移後に実行 (例: setUser)
 */
export function useFadeNavigation() {
  const navigate = useNavigate();
  const [cardVisible, setCardVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    // 初期 opacity-0 を確実にペイントしてから可視化するため次々フレームへ遅延
    let id2;
    const id1 = requestAnimationFrame(() => {
      id2 = requestAnimationFrame(() => setCardVisible(true));
    });
    return () => {
      cancelAnimationFrame(id1);
      if (id2 !== undefined) cancelAnimationFrame(id2);
    };
  }, []);

  const fadeOutThen = (afterFade) => {
    setIsLeaving(true);
    setCardVisible(false);
    setTimeout(() => afterFade(), FADE_DURATION_MS);
  };

  const navigateWithFade = (to) => {
    fadeOutThen(() => navigate(to));
  };

  return { cardVisible, isLeaving, fadeOutThen, navigateWithFade };
}
